import '../Scss/main.scss';
import { initializeSlider } from './components/slider.js';


// initialize all Components after document is ready 
$(document).ready(function() {
    initializeSlider();
});
